exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blocked-alarms-table-unit{display:inline-flex;width:100%}.blocked-alarms-table-unit-header{width:25%}.blocked-alarms-table-unit-search{width:75%;gap:10px;align-self:flex-end}\n", ""]);

// exports
